import type { BundleId } from '../data/pricing';
import { SHOP_SECTION_ID, scrollToSection } from './scroll';

export type ShopIntent = 'byo' | BundleId;
export const SHOP_INTENT_EVENT = 'mf-shop-intent';

/** Opens the matching tab in the shop section, highlights the choice and scrolls there. */
export function goToShop(intent: ShopIntent) {
  window.dispatchEvent(new CustomEvent<ShopIntent>(SHOP_INTENT_EVENT, { detail: intent }));
  window.setTimeout(() => scrollToSection(SHOP_SECTION_ID), 40);
}
